import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { PromptResponse } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  userId: number;
  options?: Omit<UseQueryOptions<unknown, Error, PromptResponse[]>, 'queryKey' | 'queryFn'>;
}

export const useUserPromptResponsesRequest = ({ userId, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, PromptResponse[]>(
    [Entities.Prompts, 'user-responses', userId],
    async () => {
      const { data } = await api.v1AdminUsersUserIdPromptResponsesGet(userId)
      return data
    },
    { ...options }
  )
}
